module.exports = __webpack_public_path__ + "static/media/file_type_audio_icon.94be597c.svg";